import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { AnalysisResult } from "../types";

export const GET_COURT_RECORDING_ANALYSIS_QUERY_KEY = (id: string) => ['court-recordings', id, 'analysis'];

export const useGetCourtRecordingAnalysis = (id: string, enabled: boolean) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_COURT_RECORDING_ANALYSIS_QUERY_KEY(id),
        queryFn: () => client.fetchApi<AnalysisResult, {}>({
            endpoint: `court-recordings/${id}/analysis`,
            method: 'GET',
        }),
        enabled: Boolean(id) && enabled,
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};
